import { IMainField } from 'components/ProjectSpecificComponents/Interfaces/DataInterface';

export default function getFieldDataByMainFieldKey(
  key: string,
  data: IMainField[],
) {
  for (let fieldData of data) {
    let { fieldId } = fieldData
    if (key.toLowerCase() == fieldId.toLowerCase()) {
      return fieldData}
  }
  return null
}
